export default __webpack_public_path__ + "static/media/grayCheckNew.9c7343b4.svg";